"use client"

import { useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { FaEnvelope, FaLock, FaSignInAlt } from "react-icons/fa"
import { useAuth } from "../context/AuthContext"
import "./AuthPage.css"

const LoginPage = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // Get the redirect path from location state or default to home
  const from = location.state?.from?.pathname || "/"

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Reset error
    setError("")

    // Validate form
    if (!email || !password) {
      setError("Por favor, preencha todos os campos")
      return
    }

    try {
      setLoading(true)
      await login(email, password)
      navigate(from, { replace: true })
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1 className="auth-title">Entrar</h1>

        {error && <div className="auth-error">{error}</div>}

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              <FaEnvelope className="input-icon" /> E-mail
            </label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu e-mail"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              <FaLock className="input-icon" /> Senha
            </label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Sua senha"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary auth-button" disabled={loading}>
            {loading ? (
              "Entrando..."
            ) : (
              <>
                <FaSignInAlt className="button-icon" /> Entrar
              </>
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Não tem uma conta? <Link to="/register">Cadastre-se</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoginPage

